class Bound {
    constructor(start_x, start_y, end_x, end_y, type = "pixel") {
  
      this.type = type;
      this.start_x = start_x;
      this.start_y = start_y;
      this.end_x = end_x;
      this.end_y = end_y;
      this.drawing = false;
    }
  
    setType(type) {
      if (type === "proportional" || type === "pixel") {
        this.type = type;
      }
    }
  
    setDrawing(drawing) {
      this.drawing = drawing;
    }
  
    setStartX(x) {
      this.start_x = x;
    }
  
    setStartY(y) {
      this.start_y = y;
    }
  
    setEndX(x) {
      this.end_x = x;
    }
  
    setEndY(y) {
      this.end_y = y;
    }
}
  
class Map {
    constructor(canvas, map_url, width, height) {
      this.canvas = canvas;
      this.drawing = false;
  
      this.bounds = [];
      this.ratio = null;
  
      this.setRatio(width, height);
      this.setBaseImage(map_url);
      this.canvas.style.backgroundSize = "contain";
      this.canvas.style.backgroundRepeat = "no-repeat";
      this.fill();
    }
  
    /**
     * Expand the canvas element so that it consumes the full width available and sets the appropriate height.
     */
    fill() {
      const parent_width = this.canvas.parentNode.offsetWidth;
      this.setWidth(parent_width);
      this.setHeight(parent_width / this.ratio);
    }
  
    /**
     * Set the base map image.
     */
    setBaseImage(img_url) {
      this.canvas.style.backgroundImage = "url(" + img_url + ")";
    }
  
    /**
     * Set the width of the canvas
     */
    setWidth(width) {
      this.canvas.width = width;
    }
  
    /**
     * Set the height of the canvas
     */
    setHeight(height) {
      this.canvas.height = height;
    }
  
    /**
     * Set the background image for the canvas to the image pointed to by img_url.
     */
     updateBase(img_url, width, height) {
      this.canvas.css('background-image', 'url(' + img_url + ')');
  
      this.canvas.attr('width', width);
      this.canvas.attr('height', height);
  
      this.setRatio(width, height);
    }
  
    /**
     * Get the canvas element.
     */
    getCanvas() {
      return this.canvas;
    }
  
    /**
     * Get the current height of the canvas element in pixels.
     */
    getHeight() {
      return this.canvas.offsetHeight;
    }
  
    /**
     * Get the current width of the canvas element in pixels.
     */
    getWidth() {
      return this.canvas.offsetWidth;
    }
  
    /**
     * If the aspect ratio hasn't been set yet, set it.
     *
     * Passing a TRUE value will force the aspect ratio to be set, even if it already exists.
     */
    setRatio(width, height) {
      this.ratio = width / height;
    }
  
    /**
     * Get the canvas context
     */
    getContext() {
      var c = this.getCanvas();
      return c.getContext('2d');
    }
  
    /**
   * Clear the canvas of all drawn shapes.
   */
    clear() {
      let ctx = this.getContext();
      const width = this.getWidth();
      const height = this.getHeight();
      ctx.clearRect(0,0, width, height);
    }
  
    /**
     * Given an x pixel coordinate, convert it into a proportional coordinate.
     * Proportional coordinates are a value betwen 0 and 1 where the coordiante is normalized by the width of the canvas.
     */
    getProportionalXCoord(x) {
      return x / this.getWidth();
    }
  
    /**
     * Given an y pixel coordinate, convert it into a proportional coordinate.
     * Proportional coordinates are a value betwen 0 and 1 where the coordiante is normalized by the height of the canvas.
     */
    getProportionalYCoord(y) {
      return y / this.getHeight();
    }
  
    /**
     * Given an x proportional coordinate, convert it into a pixel coordinate.
     */
    getPixelXCoord(x) {
      return x * this.getWidth();
    }
  
    /**
     * Given a y proportional coordinate, convert it into a pixel coordinate.
     */
    getPixelYCoord(y) {
      return y * this.getHeight();
    }
  
  
    /**
     * Convert a proportional bound into a pixel bound.
     */
    getScaledBox(bound) {
      if (bound.type === "pixel") {
        return bound;
      }
  
      const start_x = this.getPixelXCoord(bound.start_x);
      const start_y = this.getPixelYCoord(bound.start_y);
      const end_x = this.getPixelXCoord(bound.end_x);
      const end_y = this.getPixelYCoord(bound.end_y);
  
      let b = new Bound(start_x, start_y, end_x, end_y, "pixel");
      return b;
    }
  
    /**
     * Convert a pixel bound into a proportional bound.
     */
    getProportionalBox(bound) {
      if (bound.type === "proportional") {
        return bound;
      }
  
      const start_x = this.getProportionalXCoord(bound.start_x);
      const start_y = this.getProportionalYCoord(bound.start_y);
      const end_x = this.getProportionalXCoord(bound.end_x);
      const end_y = this.getProportionalYCoord(bound.end_y);
  
      let b = new Bound(start_x, start_y, end_x, end_y, "proportional");
      return b;
    }
  
    /**
     * Draw a bound on the map.
     */
    drawBound(b) {
      let bound = b;
      if (b.type === "proportional") {
        bound = this.getScaledBox(b);
      }
  
      this.drawRectangle(bound.start_x, bound.start_y, bound.end_x, bound.end_y);
    }
  
    /**
     * Draw a rectangle on the canvas.
     */
    drawRectangle(x1, y1, x2, y2) {
      var box_colour = "#C20430";
      var line_width = 2;
      var fill_transparency = 0.4;
  
      let width = x2 - x1;
      let height = y2 - y1;
  
      let ctx = this.getContext();
  
      ctx.strokeStyle = box_colour;
      ctx.lineWidth = line_width;
      ctx.strokeRect(x1, y1, width, height);
      ctx.globalAlpha = fill_transparency;
      ctx.fillStyle = box_colour;
      ctx.fillRect(x1, y1, width, height);
    }
  
}

export {
	Map as UGMap,
    Bound
}